import {
    AppBar, Grid, IconButton, Paper, Popover, Typography,
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import React, { useRef, useState } from 'react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import axios from 'axios';
import { getJsonPath, PAGE_ROUTES } from '../../utils/constants';
import {
    getLoggedInUserHasTwoFactorAuthEnabled,
    getLoggedInUserName,
    getLoggedInUserTitle,
} from '../../utils/localStorage';
import ActionButton from '../../components/ActionButton/ActionButton';
import MenuDrawer from './MenuDrawer';
import API from '../../utils/API';
import TwoFactorAuthSetUpDialog from './TwoFactorAuthSetUpDialog/TwoFactorAuthSetUpDialog';

type Props = {
    children: React.ReactNode,
};

const NavigationContainer = (props: Props) => {
    const { children } = props;
    console.log('navigation-container', props);

    const [showMenu, setShowMenu] = useState(false);
    const [showTwoFactorAuthSetUpDialog, setShowTwoFactorAuthSetUpDialog] = useState(false);

    const history = useHistory();

    const profilePopperAnchor = useRef(null);
    const [profilePopper, setProfilePopper] = useState<boolean>(false);

    const openProfilePopper = () => {
        setProfilePopper(true);
    };

    const closeProfilePopper = () => {
        setProfilePopper(false);
    };

    const logout = async () => {
        try {
            await axios.post(API.AUTH.LOGOUT);
            history.push(PAGE_ROUTES.BASE_ROUTE);
        } catch (error) {
            console.error(error);
        }
    };

    const handleMenuToggle = (toggle = false) => {
        setShowMenu(toggle);
    };

    const handleEnable2FAClick = () => {
        setShowTwoFactorAuthSetUpDialog(true);
    };

    const handleTwoFactorAuthSetUpDialogClose = () => {
        setShowTwoFactorAuthSetUpDialog(false);
    };

    return (
        <>
            <AppBar position="sticky" sx={{ zIndex: '1201' }}>
                <Paper style={{ margin: 0 }} elevation={3}>
                    <Grid container spacing={2} p={0.5} justifyContent="space-between" alignItems="center" sx={{ px: '3rem' }}>
                        <Grid item style={{ marginLeft: '-25px' }}>
                            <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="menu"
                                onClick={() => setShowMenu(!showMenu)}
                            >
                                <MenuIcon
                                    className={showMenu ? 'rotate-out' : 'rotate-in'}
                                    sx={{
                                        transition: 'transform 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
                                        fontSize: '1.8rem',
                                    }}
                                />
                            </IconButton>
                        </Grid>
                        <Grid item container sm={1} justifyContent="center">
                            <Grid item>
                                <img
                                    src={getJsonPath('/LoginScreen/nuacare_logo.svg')}
                                    alt="nuacare-logo"
                                    width="140"
                                />
                            </Grid>
                        </Grid>
                        <Grid container item sm={1} justifyContent="flex-end" alignItems="center">
                            <Grid item justifyContent="flex-end" alignItems="center">
                                <IconButton
                                    onClick={openProfilePopper}
                                    ref={profilePopperAnchor}
                                >
                                    <AccountCircleIcon
                                        style={{ fontSize: '1.8rem' }}
                                    />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </AppBar>
            <MenuDrawer open={showMenu} handleToggle={handleMenuToggle} />
            <Popover
                open={profilePopper}
                anchorEl={profilePopperAnchor.current}
                onClose={closeProfilePopper}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Paper
                    elevation={4}
                    sx={{ padding: '16px' }}
                >
                    <Grid container flexDirection="column">
                        <Grid item>
                            <Typography sx={{ fontWeight: 600, textAlign: 'center', marginBottom: '2px' }}>
                                {getLoggedInUserName()}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography
                                sx={{ fontWeight: 400, textAlign: 'center', color: 'GrayText' }}
                            >
                                {getLoggedInUserTitle()}
                            </Typography>
                        </Grid>
                    </Grid>
                    {
                        false && (
                            <Grid item sx={{ mt: 3 }}>
                                <ActionButton variant="contained" onClick={handleEnable2FAClick}>
                                    {getLoggedInUserHasTwoFactorAuthEnabled() ? 'Re-Enable 2FA' : 'Enable 2FA'}
                                </ActionButton>
                            </Grid>
                        )
                    }
                    <Grid item>
                        <ActionButton variant="contained" onClick={logout}>
                            Logout
                        </ActionButton>
                    </Grid>
                </Paper>
            </Popover>
            <Grid sx={{
                marginLeft: showMenu ? '250px' : '78px',
                boxSizing: 'border-box',
                transition: 'margin 0.4s ease-in-out',
            }}
            >
                {children}
            </Grid>
            {
                showTwoFactorAuthSetUpDialog && (
                    <TwoFactorAuthSetUpDialog
                        open={showTwoFactorAuthSetUpDialog}
                        onClose={handleTwoFactorAuthSetUpDialogClose}
                    />
                )
            }
        </>
    );
};

export default NavigationContainer;
